import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Popover } from '@uhg-abyss/web/ui/Popover';
import { t } from 'i18next';
import React, { useRef } from 'react';

import { useIsOverflow } from '../../../../../../../../../../hooks/useIsOverflow';
import { EducationInformation } from '../../../../../../../../../../models/Provider';
import {
  StyledEducationDegreeDiv,
  StyledEducationUniversityDiv,
  popoverStyle,
} from '../../../../../utility/compareDrawer.styled';
import { NULL_ATTRIBUTE_STATE } from '../../../../../utility/compareDrawerConstants';
import { getEducation } from '../../../../../utility/getEducationText';

type Props = {
  educationInfo: EducationInformation;
};

export const EducationAttributeMobile = ({ educationInfo }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const isOverflow = useIsOverflow(containerRef);

  const education = getEducation(educationInfo);
  const isUniversityEmpty =
    education.schoolName === NULL_ATTRIBUTE_STATE.EDUCATION_SCHOOLS;
  const schoolNameToDisplay = isUniversityEmpty
    ? t(education.schoolName)
    : education.schoolName;
  const isDegreeEmpty =
    education.degreeCode === NULL_ATTRIBUTE_STATE.EDUCATION_DEGREES;

  const UniversityAttribute = (
    <StyledEducationUniversityDiv
      cssProps={{ isOverflow, isUniversityEmpty }}
      ref={containerRef}
    >
      {schoolNameToDisplay}
    </StyledEducationUniversityDiv>
  );

  const DegreeAttribute = (
    <StyledEducationDegreeDiv cssProps={{ isDegreeEmpty }}>
      {isDegreeEmpty ? t(education.degreeCode) : education.degreeCode}
    </StyledEducationDegreeDiv>
  );

  return (
    <Layout.Stack alignItems="left" space={0}>
      {/* UNIVERSITY */}
      {isOverflow ? (
        <Popover
          content={schoolNameToDisplay}
          css={popoverStyle}
          showClose={false}
          tabIndex="-1"
          width={150}
        >
          {UniversityAttribute}
        </Popover>
      ) : (
        UniversityAttribute
      )}

      {/* DEGREE */}
      {isDegreeEmpty ? (
        <Popover
          content={t(education.degreeCode)}
          css={popoverStyle}
          position="bottom"
          showClose={false}
          tabIndex="-1"
          width={150}
        >
          {DegreeAttribute}
        </Popover>
      ) : (
        DegreeAttribute
      )}
    </Layout.Stack>
  );
};
